import React from 'react';
import * as ReactDOM from 'react-dom';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import styleFile from './SearchOptionsOrderBy.js';
import { RichText, Button } from '@synergycms_core/components/generic/';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import { orderByOptions } from './utils';
import actions from '../../../store/actions';
import { withThemeJSS } from 'synergycms_core/src/components/providers/themeProvider';
const { orderBy: orderByActions } = actions.customer;

const SearchOptionOrderBy = class SearchOptionOrderBy extends React.Component {
  static displayName = 'SearchOptionOrderBy';
  constructor(props) {
    super(props);

    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    this.element = ReactDOM.findDOMNode(this);
    document.addEventListener("click", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  handleClickOutside(e) {
    if (!e || (this.element.contains && document.contains && !this.element.contains(e.target) && document.contains(e.target))) {
      e && e.preventDefault();
      this.props.config.toggleSelected('order_by')(e);
    }
  }

  doSetOrderBy = code => e => {
    this.props.config.setOrderBy(code)(e);
    this.props.config.toggleSelected('order_by')(e);
  };

  render() {
    const { theme, config } = this.props;
    const { orderBy } = config;
    const { classes } = theme.styles;
    return (
      <div className={theme.computedInnerStyle}>
        <div className={classes.orderByTitle}>
          <RichText translate={true} ucFirst={true}>
            _%ordenar por%_
          </RichText>
          {this.props.theme.width < 1001 && (
            <Button
              onClick={this.props.config.toggleSelected()}
              innerStyle={['closeButton']}
              icon={{ unicodeContent: 'e001' }}
              defaultStyle={false}
              ariaLabel={'_%ordenar por%_'}
              translate={true}
            />
          )}
        </div>
        <ul className={classes.listContainer}>
          {orderByOptions.map(option => {
            return (
              <li key={option.code}>
                <Button
                  richText={{ text: option.name.toLowerCase(), translate: true, ucFirst: true }}
                  innerStyle={classes.buttonFilter}
                  disabled={orderBy === option.code}
                  onClick={this.doSetOrderBy(option.code)}
                />
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
};

const mapDispatchToProps = dispatch => {
  return {
    setOrderBy: type => () => {
      dispatch(orderByActions.set(type));
    }
  };
};

const mapStateToProps = store => {
  return {
    orderBy: store.getIn(['customer', 'order_by', 'type'])
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager(['theme', 'orderBy', 'setOrderBy', 'toggleSelected']),
  withThemeJSS({ styleFile, link: true, index: 200 })
)(SearchOptionOrderBy);
